module.exports = __webpack_public_path__ + "static/media/order_notify_green.9a744bce.png";